import '../sass/style.scss';

import 'imports-loader?define=>false!animation.gsap';
import ScrollMagic from 'ScrollMagic';
import MorphSVGPlugin from './lib/MorphSVGPlugin'
import CustomEase from './lib/CustomEase'

import { $, $$ } from './lib/bling';


// load our helper functions
const h = require('./helpers');

const defaults = {
    offset() {
        return  0 - (h.viewportHeight() * 0.25);
    },
    offsetLarge() {
        return  0 - (h.viewportHeight() * 1);
    },
    imageDuration() {
        return  h.viewportHeight() * 0.5;
    },
    imageDurationLarge() {
        return  h.viewportHeight() * 0.75;
    },
    imageDurationFull() {
        return  h.viewportHeight();
    }
}

// create our scroll magic instance
let scroll;

// we need to monitor our screen width in order to rebuid our svgs that are screen width dependent
let windowWidth = h.viewportWidth();

// set a flag to use to throttle callback functions
let resizeInProgress = false;
const resizing = () => {


    if (!resizeInProgress) {
        
        resizeInProgress = true; // throttle this function
        
        setTimeout(function() {
            
            let newWindowWidth = h.viewportWidth();

            // check whether we need to rebuild the animations
            // rebuilding of animations required when going from large to small or small to large....
            if ((windowWidth < h.breakpoints.lg && newWindowWidth >= h.breakpoints.lg) || (windowWidth >= h.breakpoints.lg && newWindowWidth < h.breakpoints.lg)) {
                console.log("rebuild the animations...");
                scroll.destroy(true);
                scroll = null;
                //prepareSVGs();
                setUpAnimations();
            }


            if (detectIE()) {
                setHeightOfSVGContainers();
            }
            
            // update the window width
            windowWidth = newWindowWidth;
            resizeInProgress = false;

        }, 50);

    }


}


/**
 * adjusts SVGs that display differently based on screen width
 * @return NULL
 * @author Bill McGlone
 */
let sceneFourSVGAmmended = false;
const sceneFourViewbox = $('#secureCloud').getAttribute('viewBox');
const sceneFourViewboxMobile = '0 0 340 1460';
const prepareSVGs = () => {

    if (h.viewportWidth() <= h.breakpoints.lg && !sceneFourSVGAmmended) {

        console.log("prepare final svg for mobile");       

        TweenLite.set('#Cloud', { x: '-=60' } );

        TweenLite.set('#secureCloud', { transformOrigin: '0 0', scale : 1.6 } );

        // move the main timeline left
        TweenLite.set(['#lineSection1', '#lineSection2', '#lineSection3', '#lineSection4'], { attr: { x1: '-=130', x2: '-=130', y1: '+=20', y2: '+=20' } } );
        // and extend the lines
        //TweenLite.set(['#lineSection2', '#lineSection3', '#lineSection4'], { attr: { y1: '-=100', y2: '-=100' } } );
        // move the sections on the right over to the left
        TweenLite.set(['#CompleteOpen', '#CompleteClosed', '#CollaborativeOpen', '#CollaborativeClosed'], { x: '-=130', y: '+=20' } );
        // and the ones form the left to the right a bit....
        TweenLite.set(['#ConnectedClosed', '#ChoiceOpen', '#ChoiceClosed' ], { x: '+=83', y: '+=20' } );
        // move the groups down
        TweenLite.set(['#group1', '#Group2', '#Group3'], { y: '+=100' } );


        // move the dot for the 2 on the left...
        TweenLite.set(['#selectedLine2'], { attr: { x1: '-=155', x2: '-=155' } });
        TweenLite.set('#selectedCircle2', { attr: { cx: '-=213' } } );
        TweenLite.set('#selectedPoint2', { x: '-=98' } );
        TweenLite.set('#line_points_rightOPEN-2', { x: '+=112'});

        // move the elements on the left to the right and flip them
        // push down group 2, 3 and 4
        // update the viewbox....


        // set the mobile viewbox
        $('#secureCloud').setAttribute('viewBox', sceneFourViewboxMobile)

        // and flag that we have altered the SVG
        sceneFourSVGAmmended = true;

        return;

    }

    if (sceneFourSVGAmmended) {

        console.log("reset the SVG!");

        console.log($('#secureCloud').getBBox().height);
        const viewboxWidth = $('#secureCloud').getBBox().width;


        TweenLite.set('#Cloud', { x: '+=60' } );
        TweenLite.set('#secureCloud', { transformOrigin: '0 0', scale : 1 } );

        // move the main timeline back
        TweenLite.set(['#lineSection1', '#lineSection2', '#lineSection3', '#lineSection4'], { attr: { x1: '+=130', x2: '+=130', y1: '-=20', y2: '-=20' } } );
        // move the sections on the right back
        TweenLite.set(['#CompleteOpen', '#CompleteClosed', '#CollaborativeOpen', '#CollaborativeClosed'], { x: '+=130', y: '-=20' } );
        // move the groups back up
        TweenLite.set(['#group1', '#Group2', '#Group3'], { y: '-=100' } );


        // set the default viewbox height
        $('#secureCloud').setAttribute('viewBox', sceneFourViewbox)

        // and flag that we have the default SVG in place
        sceneFourSVGAmmended = false;

    }

}


// the function to set our animations!
const setUpAnimations = () => {

    let scenes = []; // we will add our scens to this container as we create them
    scroll = new ScrollMagic.Controller(); // create our container...
    
    /**
     * Define the animations that must be reset when the animations are rebuilt
     */
    let animateOutsideBubbleOne,
        animateOutsideBubbleTwo,
        animateOutsideBubbleThree,
        animateInsideBubbleOne,
        animateInsideBubbleTwo,
        animateInsideBubbleThree;
    

    /**
     * Animate the intro graphic 
     */
    
    const introAnimation = new TimelineMax();
    introAnimation
        .fromTo('#IntroGraphicArrowLine', 1, { strokeDashoffset : 150, visibility: 'hidden' }, { strokeDashoffset : '0', visibility: 'visible', ease: Power2.easeInOut }, 0.5)
        .fromTo('#clipForLeftArrowPartRect', 0.3, { x: '+0' }, { x: '-34', ease: Power2.easeOut }, 1.15)
        .fromTo('#clipForRightArrowPartRect', 0.3, { y: '+0' }, { y: '+36', ease: Power2.easeOut }, 1.15)
        .fromTo('#tippoint_x5F_squere', 0.1, { visibility: 'hidden'}, {  visibility : 'visible' }, 1.15);

    const sceneIntro = new ScrollMagic.Scene({
        triggerElement: '#intro_trigger'
    }).setTween(introAnimation);

    // add it to our scenes holder
    scenes.push(sceneIntro);

    /**
     * Scene One
     */

     // animate numbers and progress

    let sceneOneNumberOne = { var: 0 };
    const sceneOneNumberOneCountdown = TweenMax.to(sceneOneNumberOne, 1, {
        var: parseInt($('#s1_number_1').getAttribute('data-target')), 
        onUpdate: function () {
            $('#s1_number_1').innerHTML = Math.ceil(sceneOneNumberOne.var);
            $('#s1_progress_1').style.width = `${sceneOneNumberOne.var}%`;
        },
        ease:Circ.easeOut
    });   

    let sceneOneNumberTwo = { var: 0 };
    const sceneOneNumberTwoCountdown = TweenMax.to(sceneOneNumberTwo, 1, {
        var: parseInt($('#s1_number_2').getAttribute('data-target')), 
        onUpdate: function () {
            $('#s1_number_2').innerHTML = Math.ceil(sceneOneNumberTwo.var);
            $('#s1_progress_2').style.width = `${sceneOneNumberTwo.var}%`;
        },
        ease:Circ.easeOut
    });   

    const animateBlinkingIcon = new TimelineMax( { repeat: -1, repeatDelay: 1.5 } );
    animateBlinkingIcon
        .to('#eyeOut', 0.5, { scaleX : 1, scaleY : 0.1, transformOrigin: '0 50%', ease: Power2.easeOut}, 0 )
        .to('#clipForEyeBlinkRect', 0.5, { attr: { height : 12, y: 68 }, ease: Power2.easeOut }, 0)
        .to('#eyeIn', 0.1, { visibility : 'hidden'}, 0.5)
        .to('#financial_services', 0.1, { visibility : 'visible'}, 0.5)
        .to('#eyeOut', 0.3, { scaleX : 1, scaleY : 1, transformOrigin: '0 50%', ease: Power2.easeOut}, 0.5)
        .to('#clipForEyeBlinkRect', 0.3, { attr: { height : 112, y: 18 }, ease: Power2.easeOut }, 0.5)
        
        .to('#eyeOut', 0.5, { scaleX : 1, scaleY : 0.1, transformOrigin: '0 50%', ease: Power2.easeOut}, 2.5)
        .to('#clipForEyeBlinkRect', 0.5, { attr: { height : 12, y: 68 }, ease: Power2.easeOut }, 2.5)
        .to('#financial_services', 0.1, { visibility : 'hidden'}, 3)
        .to('#dataMagGlass', 0.1, { visibility : 'visible'}, 3)
        .to('#eyeOut', 0.3, { scaleX : 1, scaleY : 1, transformOrigin: '0 50%', ease: Power2.easeOut}, 3)
        .to('#clipForEyeBlinkRect', 0.3, { attr: { height : 112, y: 18 }, ease: Power2.easeOut }, 3)

        .to('#eyeOut', 0.5, { scaleX : 1, scaleY : 0.1, transformOrigin: '0 50%', ease: Power2.easeOut}, 5)
        .to('#clipForEyeBlinkRect', 0.5, { attr: { height : 12, y: 68 }, ease: Power2.easeOut }, 5)
        .to('#dataMagGlass', 0.1, { visibility : 'hidden'}, 5.5)
        .to('#pieChart', 0.1, { visibility : 'visible'}, 5.5)
        .to('#eyeOut', 0.3, { scaleX : 1, scaleY : 1, transformOrigin: '0 50%', ease: Power2.easeOut}, 5.5)
        .to('#clipForEyeBlinkRect', 0.3, { attr: { height : 112, y: 18 }, ease: Power2.easeOut }, 5.5)

        .to('#eyeOut', 0.5, { scaleX : 1, scaleY : 0.1, transformOrigin: '0 50%', ease: Power2.easeOut}, 7.5)
        .to('#clipForEyeBlinkRect', 0.5, { attr: { height : 12, y: 68 }, ease: Power2.easeOut }, 7.5)
        .to('#pieChart', 0.1, { visibility : 'hidden' }, 8)
        .to('#eyeIn', 0.1, { visibility : 'visible' }, 8)
        .to('#eyeOut', 0.3, { scaleX : 1, scaleY : 1, transformOrigin: '0 50%', ease: Power2.easeOut}, 8)
        .to('#clipForEyeBlinkRect', 0.3, { attr: { height : 112, y: 18 }, ease: Power2.easeOut }, 8);

    const sceneOneA = new ScrollMagic.Scene({
        triggerElement: '#s1_trigger_1',
        offset: defaults.offset()
    }).setTween(sceneOneNumberOneCountdown);
    
    const sceneOneB = new ScrollMagic.Scene({
        triggerElement: '#s1_trigger_2',
        offset: defaults.offset()
    }).setTween(sceneOneNumberTwoCountdown);
    
    const sceneOneC = new ScrollMagic.Scene({
        triggerElement: '#s1_trigger_3',
        offset: defaults.offset()
    }).setTween(animateBlinkingIcon)
    .on('start', function(event) {
        animateBlinkingIcon.time(0);
    });

    // add it to our scenes holder
    scenes.push(sceneOneA);
    scenes.push(sceneOneB);
    scenes.push(sceneOneC);

    // animate the microscope
    const animateMicroscopeNumber = TweenMax.to('#s1_micro_number', 1.9, { x : '+=150', delay : 0.1, ease: Power2.easeInOut } );
    const animateMicroscope = TweenMax.to('#s1_micro', 2, { x : '+=150', ease: Power2.easeInOut } );

    let sceneOneMicroscopeNumber = { var: 0 };
    const sceneOneMicroscopeNumberCountdown = TweenMax.to(sceneOneMicroscopeNumber, 1.9, {
        var: 63, 
        onUpdate: function () {
            $('#s1_micro_number').innerHTML = Math.ceil(sceneOneMicroscopeNumber.var)+'%';
        },
        ease: Power2.easeInOut
    });   

    const sceneOneD = new ScrollMagic.Scene({
        triggerElement: '#s1_trigger_4',
        offset: defaults.offset(),
        reverse: true
    }).setTween([animateMicroscopeNumber, animateMicroscope, sceneOneMicroscopeNumberCountdown]);
    

    // add it to our scenes holder
    scenes.push(sceneOneD);


    /**
     * Scene Two
     */
    const s2Timings = {
        
        red: 0,
        blue: 0.5,
        yellow: 1,
        sq: 2,
        tri: 2.1,
        circ: 2.2
    }
    
    // animate the data visualisation graphic
    const animateDataVisualisation = new TimelineMax();

    animateDataVisualisation
        
        // animate the red line and the icons
        .to('#lineRed_1_', 1, { attr: { y2: '-=20' }, ease: Power2.easeOut }, s2Timings.red)
        .to('#DV_Red', 1, { y: '-=25', scale: 1.4, transformOrigin: '50% 50%', ease: Power2.easeOut }, s2Timings.red)
        .to('#DV_Red', 0.1, { scaleX: 0, transformOrigin: '50% 0%' }, s2Timings.red + 1)
        .to('#DV_Red', 0.1, { scaleX: 1.4 }, s2Timings.red + 1.1)
        .to('#RedSquereInside', 0.4, { x: '+=3', y: '-=3'}, s2Timings.red + 1.2)
        
        // animate the blue line and the icons
        .to('#lineBlue_1_', 1, { attr: { y2: '-=11' }, ease: Power2.easeOut }, s2Timings.blue)
        .to('#DV_Blue', 1, { y: '-=15', scale: 1.4, transformOrigin: '50% 50%', ease: Power2.easeOut}, s2Timings.blue)
        .to('#DV_Blue', 0.1, { scaleX: 0, transformOrigin: '50% 0%' }, s2Timings.blue + 1)
        .to('#DV_Blue', 0.1, { scaleX: 1.4 }, s2Timings.blue + 1.1)
        .to('#pieElement_1_', 0.4, { x: '-=1.3', y: '-=2'}, s2Timings.blue + 1.2)

        // animate the yellow line and the icons
        .to('#lineYellow', 1, { attr: { y2: '-=50' }, ease: Power2.easeOut }, s2Timings.yellow)
        .to('#Yellow', 1, { y : '-=70', scale: 2.6, transformOrigin: '50% 50%', ease: Power2.easeOut }, s2Timings.yellow)
        // rotate the square
        .to('#YellowSq_1_', 0.1, { scaleY : 0, transformOrigin: '50% 50%' }, s2Timings.sq)
        .to('#YellowSq_1_', 0, {fill: '#cf7b0b' }, s2Timings.sq + 0.1)
        .to('#YellowSq_1_', 0.1, { scaleY : 1 }, s2Timings.sq + 0.1)
        .to('#YellowSq_1_', 0.1, { scaleY : 0 }, s2Timings.sq + 0.2)
        .to('#YellowSq_1_', 0, {fill: '#F29111' }, s2Timings.sq + 0.3)
        .to('#YellowSq_1_', 0.1, { scaleY : 1 }, s2Timings.sq + 0.3)
        // rotate the triangle
        .to('#YellowTriangle_1_', 0.1, { scaleY : 0, transformOrigin: '50% 50%' }, s2Timings.tri)
        .to('#YellowTriangle_1_', 0, {fill: '#cf7b0b' }, s2Timings.tri + 0.1)
        .to('#YellowTriangle_1_', 0.1, { scaleY : 1 }, s2Timings.tri + 0.1)
        .to('#YellowTriangle_1_', 0.1, { scaleY : 0 }, s2Timings.tri + 0.2)
        .to('#YellowTriangle_1_', 0, {fill: '#F29111' }, s2Timings.tri + 0.3)
        .to('#YellowTriangle_1_', 0.1, { scaleY : 1 }, s2Timings.tri + 0.3)
        // rotate the circle
        .to('#YellowCircle_1_', 0.1, { scaleY : 0, transformOrigin: '50% 50%' }, s2Timings.circ)
        .to('#YellowCircle_1_', 0, {fill: '#cf7b0b' }, s2Timings.circ + 0.1)
        .to('#YellowCircle_1_', 0.1, { scaleY : 1 }, s2Timings.circ + 0.1)
        .to('#YellowCircle_1_', 0.1, { scaleY : 0 }, s2Timings.circ + 0.2)
        .to('#YellowCircle_1_', 0, {fill: '#F29111' }, s2Timings.circ + 0.3)
        .to('#YellowCircle_1_', 0.1, { scaleY : 1 }, s2Timings.circ + 0.3)
        ;


    const sceneTwoA = new ScrollMagic.Scene({
        triggerElement: '#s2_trigger_1',
        offset: defaults.offset()
    }).setTween(animateDataVisualisation);


    // animate numbers
    let s2Num1 = { var: 0 };
    const s2Num1Countdown = TweenMax.to(s2Num1, 1, {
        var: parseInt($('#s2_number_1').getAttribute('data-target')), 
        onUpdate: function () {
            $('#s2_number_1').innerHTML = Math.ceil(s2Num1.var);
        },
        ease: Power2.easeInOut
    }); 

    const sceneTwoB = new ScrollMagic.Scene({
        triggerElement: '#s2_trigger_2',
        offset: defaults.offset()
    }).setTween(s2Num1Countdown);


    // add it to our scenes holder
    scenes.push(sceneTwoA);
    scenes.push(sceneTwoB);


    /**
     * Scene Three
     */
    
    // animate the numbers

    let s3Num1 = { var: 0 };
    const s3Num1Countdown = TweenMax.to(s3Num1, 1, {
        var: parseInt($('#s3_number_1').getAttribute('data-target')), 
        onUpdate: function () {
            $('#s3_number_1').innerHTML = Math.ceil(s3Num1.var);
        },
        ease: Power2.easeInOut
    }); 

    let s3Num2 = { var: 0 };
    const s3Num2Countdown = TweenMax.to(s3Num2, 1, {
        var: parseInt($('#s3_number_2').getAttribute('data-target')), 
        onUpdate: function () {
            $('#s3_number_2').innerHTML = Math.ceil(s3Num2.var);
        },
        ease: Power2.easeInOut
    });   
    
    let s3Num3 = { var: 0 };
    const s3Num3Countdown = TweenMax.to(s3Num3, 1, {
        var: parseInt($('#s3_number_3').getAttribute('data-target')), 
        onUpdate: function () {
            $('#s3_number_3').innerHTML = Math.ceil(s3Num3.var);
        },
        ease: Power2.easeInOut
    });   

    const sceneThreeA = new ScrollMagic.Scene({
        triggerElement: '#s3_trigger_1',
        offset: defaults.offset()
    }).setTween(s3Num1Countdown);
    
    const sceneThreeC = new ScrollMagic.Scene({
        triggerElement: '#s3_trigger_3',
        offset: defaults.offset()
    }).setTween(s3Num2Countdown);
    
    const sceneThreeF = new ScrollMagic.Scene({
        triggerElement: '#s3_trigger_6',
        offset: defaults.offset()
    }).setTween(s3Num3Countdown);


    // bubbling animation

    let bubbleMotionPath = MorphSVGPlugin.pathDataToBezier("#cloudMotionPath", {align:"#bubbling_bubble_large_outside"});
    bubbleMotionPath = bubbleMotionPath.reverse();

    const delayStart = 0;

    const animateBubblingIdeas = new TimelineMax();
    animateBubblingIdeas
        .set("#bubbling_bubble_large_outside", { xPercent: -50, yPercent: -50, x: bubbleMotionPath[0]['x'], y: bubbleMotionPath[0]['y'], visibility: 'visible' })
        .set('#bubbling_product', { y: '43px' })
        .set('#cloudThisoneSmall', { visibility: 'visible', opacity: 0, x : '+=10' })
        .set('#cloudThisoneLarge', { visibility: 'visible', opacity: 0, x : '+=10' })
        

        .to("#bubbling_bubble_large_outside", 0.2, { opacity: 0.5}, delayStart + 2.8)
        .to("#bubbling_bubble_large_outside", 2, { morphSVG: '#bubbling_cloud1tiny', transformOrigin: '50% 50%', scaleX : 8, scaleY: 8, opacity: 0.8 }, delayStart + 3)
        .to('#cloudThisoneSmall', 0.5, { opacity: 0.7, x : '-=10'}, delayStart + 4)
        .to('#cloudThisoneLarge', 0.5, { opacity: 0.8, x : '-=10'}, delayStart + 4.5)
        

        .to("#bubbling_bubble_large_outside", 5, { bezier: { values:bubbleMotionPath, type:"cubic" }, ease: CustomEase.create("custom", "M0,0 C0,0 0.132,0.05 0.5,0.2 0.828,0.333 1,1 1,1")}, delayStart)
        

        .to('#bubbling_bubble_large_outside', 0.2, { visibility: 'hidden' }, delayStart + 5)
        .fromTo('#bubbling_poof', 0.15, { visibility: 'visible', scaleX: 0, scaleY: 0, y: '+=10', transformOrigin: '50% 50%' }, { scaleX: 1.3, scaleY: 1.3, ease:Power2.easeOut }, delayStart + 5)
        .to('#bubbling_product_1_', 0, { visibility: 'visible' })
        .to('#bubbling_poof', 0.15, { scaleX: 0, scaleY: 0, ease:Power2.easeIn})
        .to('#bubbling_LidSolidClosed', 0.3, { morphSVG: { shape: '#bubbling_LidSolidUp', shapeIndex: 6 }, ease: Power2.easeOut })
        .to('#bubbling_product', 0, { visibility: 'visible' } )
        .to('#bubbling_product', 1, { y: 0, ease: Power2.easeOut } )

        ;

    const sceneThreeB = new ScrollMagic.Scene({
        triggerElement: '#s3_trigger_2',
        offset: defaults.offset()
    })
    .setTween(animateBubblingIdeas)
    .on('start', function (event) {
        animateBubblingIdeas.time(0);
    });


    const bubblesInsideTop = 190;
    
    setTimeout(function() {
        animateInsideBubbleOne = TweenMax.fromTo('#bubbling_bubble_grande', 2, { attr: { cy : 281 } }, { attr: { cy : bubblesInsideTop }, repeat: -1 } );
    }, 1250);
    setTimeout(function() {
        animateInsideBubbleTwo = TweenMax.fromTo('#bubbling_bubble_mid_inside_bottom', 1.8, { attr: { cy : 276 } }, { attr: { cy : bubblesInsideTop }, repeat: -1 } );
    }, 1750);
    setTimeout(function() {
        animateInsideBubbleThree = TweenMax.fromTo('#bubbling_bubble_tiny_inside', 1.6, { attr: { cy : 292 } }, { attr: { cy : bubblesInsideTop }, repeat: -1 } );
    }, 2250);


    const bubblesOutsideTop = 85;
    
    setTimeout(function() {
        animateOutsideBubbleOne = new TimelineMax( {repeat: -1 } );
        animateOutsideBubbleOne
            .fromTo('#bubbling_bubble_large_inside', 4, { attr: { cy : 230 }, opacity: 1 }, { attr: { cy : bubblesOutsideTop } }, 0 )
            .to('#bubbling_bubble_large_inside', 0.5, { transformOrigin : '50% 50%', opacity : 0, scale : 1.1 }, 3.5 );
    }, 2750);
    
    setTimeout(function() {
        animateOutsideBubbleTwo = new TimelineMax( {repeat: -1 } );
        animateOutsideBubbleTwo
            .fromTo('#bubbling_bubble_mid_inside', 3.8, { attr: { cy : 220 }, opacity: 1 }, { attr: { cy : bubblesOutsideTop - 15 } }, 0 )
            .to('#bubbling_bubble_mid_inside', 0.3, { transformOrigin : '50% 50%', opacity : 0, scale : 1.2 }, 3.5 );
    }, 2500);
    
    setTimeout(function() {
        animateOutsideBubbleThree = new TimelineMax( { repeat: -1 } );
        animateOutsideBubbleThree
            .fromTo('#bubbling_bubble_mid_outside', 3.6, { attr: { cy : 240 }, opacity: 1 }, { attr: { cy : bubblesOutsideTop - 30 } }, 0 )
            .to('#bubbling_bubble_mid_outside', 0.3, { transformOrigin : '50% 50%', opacity : 0, scale : 1.3 }, 3.3 );  
    }, 4000);

    // animate the cloud arrows
    const animateCloudArrows = new TimelineMax();
    animateCloudArrows
        .fromTo('#IntroGraphicArrowLineB', 1.25, { strokeDashoffset : 150, visibility: 'hidden' }, { strokeDashoffset : '0', visibility: 'visible', ease: Power2.easeInOut }, 0.5)
        .fromTo('#IntroGraphicArrowLineB_1_', 1, { strokeDashoffset : 150, visibility: 'hidden' }, { strokeDashoffset : '0', visibility: 'visible', ease: Power2.easeInOut }, 0.5)
        .fromTo('#clipForLeftArrowPartARect', 0.3, { x: '+0' }, { x: '-34', ease: Power2.easeOut }, 1.4)
        .fromTo('#clipForLeftArrowPartBRect', 0.3, { x: '+0' }, { x: '-34', ease: Power2.easeOut }, 1.15)
        .fromTo('#clipForRightArrowPartARect', 0.3, { y: '+0' }, { y: '+36', ease: Power2.easeOut }, 1.4)
        .fromTo('#clipForRightArrowPartBRect', 0.3, { y: '+0' }, { y: '+36', ease: Power2.easeOut }, 1.15)
        .fromTo('#tippoint_x5F_squereA', 0.1, { visibility: 'hidden'}, {  visibility : 'visible' }, 1.4)
        .fromTo('#tippoint_x5F_squereB', 0.1, { visibility: 'hidden'}, {  visibility : 'visible' }, 1.15);


    const sceneThreeE = new ScrollMagic.Scene({
        triggerElement: '#s3_trigger_5',
        offset: defaults.offset()
    }).setTween(animateCloudArrows);


    // animate the decision makers
    // let tm1 = TweenMax
    //     .to('#woman', 3, {
    //         bezier:[
    //             {x: '60', y: '111'},
    //             {x: '-60', y: '111'},
    //             {x: '0', y: '0'},
    //         ]
    //     })
    //     .to('#ManInGrey', 3, {
    //         bezier:[
    //             {x: '-120', y: '0'},
    //             {x: '-60', y: '-111'},
    //             {x: '0', y: '0'},
    //         ]
    //     }
    // );

    // const mov = {
    //     left : 60,
    //     right : -60,
    //     bottom : 111,
    //     top : -111
    // };

    // const animateDecisionMakers = new TimelineMax({paused:true, repeat: -1});
    // animateDecisionMakers
    //     .to('#woman', 3, {
    //         bezier:[
    //             {x: mov.left, y: mov.bottom * 0.15}, // top to bottom left transition
    //             {x: mov.left, y: mov.bottom}, // bottom left
    //             {x: 0, y : mov.bottom * 1.5}, // bottom transtion point....
    //             {x: mov.right, y: mov.bottom}, // bottom right
    //             {x: mov.right, y: mov.bottom * 0.15}, // bottom right to top transition
    //             {x: 0, y: 0}, // top (starting position)
    //         ],
    //         ease: Power0.easeNone
    //     }, 0)
    //     .to('#ManInGrey', 3, {
    //         bezier:[
    //             {x: mov.right, y: mov.bottom * 0.5}, // bottom transtion point....
    //             {x: mov.right * 2, y: 0}, // bottom right
    //             {x: mov.right * 2, y:  mov.top * 0.85}, // bottom right to top transition
    //             {x: mov.right, y: mov.top}, // top
    //             {x: 0, y: mov.top * 0.85}, // top to left transition 1
    //             {x: 0, y: 0}, // bottom left (starting position)
    //         ],
    //         ease: Power0.easeNone
    //     }, 0)
    //     .to('#manInSuit', 3, {
    //         bezier:[
    //             {x: 0, y:  mov.top * 0.85}, // bottom right to top transition
    //             {x: mov.left, y: mov.top}, // top
    //             {x: mov.left * 2, y: mov.top * 0.85}, // top to left transition
    //             {x: mov.left * 2, y: 0}, // bottom left
    //             {x: mov.left, y: mov.bottom * 0.5}, // bottom transtion point....
    //             {x: 0, y: 0}, // bottom right (starting position)
    //         ], 
    //         ease: Power0.easeNone
    //     }, 0)
    //     .to('#pathContainer', 3, { rotation: 360, transformOrigin: '50% 63%', ease: Power0.easeNone }, 0);

    // const animateDecisionMakersDuration = animateDecisionMakers.duration();
    
    // function doSomething() {

    //     TweenLite.to(animateDecisionMakers, 3, {progress:1, ease: Power0.easeNone});
    //     setTimeout(function() {
    //         TweenLite.to(animateDecisionMakers, 0, {progress:0});
    //     }, 1000);

    // }

    // doSomething();
    // function startAnimateDecisionMakers() {

    //     animateDecisionMakers.paused(!animateDecisionMakers.paused());
    //     setTimeout(function() {
    //         animateDecisionMakers.paused(!animateDecisionMakers.paused());
    //         setTimeout(function() {
    //             startAnimateDecisionMakers();
    //         }, 3000);
    //     }, (animateDecisionMakersDuration/3) * 1000);
    // }


    //startAnimateDecisionMakers();



    // const dma = new TimelineMax();

    // dma
    // .to('#woman', 3, {
    //     bezier:[
    //         {x: '71px', y: '15px'}, // 
    //         {x: '71px', y: '96px'}, // 
    //         {x: '61px', y: '111px'}, // BOTTOM LEFT
    //     ],
    //     ease: Power0.easeNone
    // }, 0)
    // .to('#ManInGrey', 3, {
    //     bezier:[
    //         {x: '-21.5px', y: '25px'}, 
    //         {x: '-77px', y: '50px'}, 
    //         {x: '-85.5px', y: '25px'},
    //         {x: '-114px', y: 0}
    //     ],
    //     ease: Power0.easeNone
    // }, 0)


    // add it to our scenes holder
    scenes.push(sceneThreeA);
    scenes.push(sceneThreeB);
    scenes.push(sceneThreeC);
    scenes.push(sceneThreeE);
    scenes.push(sceneThreeF);


    








    /**
     * Scene 4
     */

    let timelineSVG = $('#secureCloud').getBBox();

    const animationTimes = 1;

    // get the expanded heights
    const sectionOneExpandedHeight = $('#secureCloudText1').getBBox().height;
    const sectionTwoExpandedHeight = $('#secureCloudText2').getBBox().height;
    const sectionThreeExpandedHeight = $('#secureCloudText3').getBBox().height;
    
    // get the full height once the svg is expanded
    const viewBoxHeight = timelineSVG.height + sectionOneExpandedHeight + sectionTwoExpandedHeight + sectionThreeExpandedHeight;

    console.log(timelineSVG.height);
    console.log(viewBoxHeight);
    // set the viewbox
    //$('#secureCloud').setAttribute('viewBox', `0 0 ${Math.ceil(timelineSVG.width)}  ${Math.ceil(viewBoxHeight)}`)

    const mobileView = h.viewportWidth() <= h.breakpoints.lg ? true : false;


    const animateTimelineSceneOne = new TimelineMax();
    animateTimelineSceneOne
        
        .to('#selectedPoint1', 0.25, { x: '+=105', ease: Power2.easeIn }, 0) // transition the dot to the right
        .to('#selectedLine1', 0.25, { attr: { x2: '+=105' }, ease: Power2.easeIn }, 0) // and expand the line along with the dot...
        .to('#timelineTitleClosed1', 0.25, { x: '+=110', ease: Power2.easeIn }, 0) // push the title out to the right too
        

        .to('#selectedPoint1', 0.25, { x: 0, morphSVG: '#selectedPoint1To'}, 0.25)  // morph the cirlce into the square...
        .fromTo('#bounceCircle1', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, 0.5 ) // bounce the circle...
        
        
        .to('#icon1Closed', 0.3, { x: '+=110', ease: Circ.easeIn }, 0 ) // animate the icon out of view
        .fromTo('#icon1Open', 0.3, { attr: { opacity: 1 }, x: '-=115' }, { x: '+=115', ease: Circ.easeOut }, 0.3 ) // animate the icon back into view



        .fromTo('#timelineTitleOpen1', 0.2, { transformOrigin : '50% 100%', visibility: 'visible', scaleY : 0, scaleX: 0.8 }, { scaleY : 1, scaleX: 1, ease: Power2.easeIn }, 0.75 )
        
        .to('#lineSection2', 0.3, { attr : { y1 : `+=${sectionOneExpandedHeight}` }, ease: Circ.easeIn }, 0.5) // expand the line on the left
        .to('#group1', 0.3, { y : `+=${sectionOneExpandedHeight}`, ease: Circ.easeIn}, 0.5) // move the group below down
        .fromTo('#secureCloudTextGroup1', 0.3, { y: -71, visibility: 'visible' }, { y : 0, ease: Circ.easeIn }, 0.5); // animate the copy into view

    const sceneFourA = new ScrollMagic.Scene({
        triggerElement: '#s4_trigger_1',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneOne)
    .on('start', function (event) {
        animateTimelineSceneOne.time(0);
    });

    


    const timelineTwoX = {
        x1 : mobileView ? '+=105' : '-=105',
        x2 : mobileView ? '+=145' : '-=145',
        x3 : mobileView ? '-=145' : '+=145'
    }

    const animateTimelineSceneTwo = new TimelineMax();

    //findShapeIndex('#selectedPoint1', '#selectedPoint1To');
    animateTimelineSceneTwo
        
        .to('#timelineTitleClosed2', 0.25, { x: timelineTwoX.x1, ease: Power2.easeIn }, 0) // push the title out to the left too

        .fromTo('#bounceCircle2', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, 0.5 ) // bounce the circle...

        .to('#icon2Closed', 0.3, { x: timelineTwoX.x1, ease: Circ.easeIn }, 0 ) // animate the icon out of view
        .fromTo('#icon2Open', 0.3, { attr: { opacity: 1 }, x: timelineTwoX.x2 }, { x: timelineTwoX.x3, ease: Circ.easeOut }, 0.3 ) // animate the icon back into view

        .fromTo('#timelineTitleOpen2', 0.2, { transformOrigin : '50% 100%', visibility: 'visible', scaleY : 0, scaleX: 0.8 }, { scaleY : 1, scaleX: 1, ease: Power2.easeIn }, 0.75 )       
        
        .to('#lineSection3', 0.3, { attr : { y1 : `+=${sectionTwoExpandedHeight}` }, ease: Circ.easeIn }, 0.5) // expand the line on the left
        .to('#Group2', 0.3, { y : `+=${sectionTwoExpandedHeight}`, ease: Circ.easeIn}, 0.5) // move the group below down
        .fromTo('#secureCloudTextGroup2', 0.3, { y: -71, visibility: 'visible' }, { y : 0, ease: Circ.easeIn }, 0.5); // animate the copy into view


    if (mobileView) {
        animateTimelineSceneTwo
            .to('#selectedPoint2', 0.25, { x: '+=105', ease: Power2.easeIn }, 0) // transition the dot to the right
            .to('#selectedLine2', 0.25, { attr: { x1: timelineTwoX.x1 }, ease: Power2.easeIn }, 0)
            .to('#selectedPoint2', 0.25, { x: '+=105', morphSVG: '#selectedPoint2To'}, 0.25);  // morph the cirlce into the square...
    } else {
        animateTimelineSceneTwo
            .to('#selectedPoint2', 0.25, { x: timelineTwoX.x1, ease: Power2.easeIn }, 0) // transition the dot to the right
            .to('#selectedLine2', 0.25, { attr: { x2: timelineTwoX.x1 }, ease: Power2.easeIn }, 0)
            .to('#selectedPoint2', 0.25, { x: 0, morphSVG: '#selectedPoint2To'}, 0.25)  // morph the cirlce into the square...
    }


    let animateTimelineSceneTwoTimeout;
    
    const sceneFourB = new ScrollMagic.Scene({
        triggerElement: '#s4_trigger_2',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneTwo)
    .on('start', function (event) {
        
        clearTimeout(animateTimelineSceneTwoTimeout);
        // check the scene before has finished....
        const prevSceneTime = animateTimelineSceneOne.time();

        if (prevSceneTime <= animationTimes && prevSceneTime !== 0) {
            animateTimelineSceneTwo.paused(true);
            animateTimelineSceneTwo.time(0);
            const waitFor = (animationTimes - prevSceneTime) * 1000;
            animateTimelineSceneTwoTimeout = setTimeout(function() {
                animateTimelineSceneTwo.paused(false);
            }, waitFor);
        } else {
            animateTimelineSceneTwo.time(0);
            animateTimelineSceneTwo.paused(false);
        }

    });


    const animateTimelineSceneThree = new TimelineMax();
    animateTimelineSceneThree
        
        .to('#selectedPoint3', 0.25, { x: '+=105', ease: Power2.easeIn }, 0) // transition the dot to the right
        .to('#selectedLine3', 0.25, { attr: { x2: '+=105' }, ease: Power2.easeIn }, 0) // and expand the line along with the dot...
        .to('#timelineTitleClosed3', 0.25, { x: '+=110', ease: Power2.easeIn }, 0) // push the title out to the right too

        .to('#selectedPoint3', 0.25, { x: 0, morphSVG: '#selectedPoint3To'}, 0.25)  // morph the cirlce into the square...
        .fromTo('#bounceCircle3', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, 0.5 ) // bounce the circle...

        .to('#icon3Closed', 0.3, { x: '+=110', ease: Circ.easeIn }, 0 ) // animate the icon out of view
        .fromTo('#icon3Open', 0.3, { attr: { opacity: 1 }, x: '-=125' }, { x: '+=125', ease: Circ.easeOut }, 0.3 ) // animate the icon back into view

        .fromTo('#timelineTitleOpen3', 0.2, { transformOrigin : '50% 100%', visibility: 'visible', scaleY : 0, scaleX: 0.8 }, { scaleY : 1, scaleX: 1, ease: Power2.easeIn }, 0.75 )
        
        .to('#lineSection4', 0.3, { attr : { y1 : `+=${sectionThreeExpandedHeight}` }, ease: Circ.easeIn }, 0.5) // expand the line on the left
        .to('#Group3', 0.3, { y : `+=${sectionThreeExpandedHeight}`, ease: Circ.easeIn }, 0.5) // move the group below down
        .fromTo('#secureCloudTextGroup3', 0.3, { y: -71, visibility: 'visible' }, { y : 0, ease: Circ.easeIn }, 0.5) // animate the copy into view


        ;

    let animateTimelineSceneThreeTimeout;
    
    const sceneFourC = new ScrollMagic.Scene({
        triggerElement: '#s4_trigger_3',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneThree)
    .on('start', function (event) {

        clearTimeout(animateTimelineSceneThreeTimeout);
        const firstSceneTime = animateTimelineSceneOne.time();
        
        if (firstSceneTime === 0) {
            animateTimelineSceneThree.time(0);
            animateTimelineSceneThree.paused(false);
            return;
        }

        const prevSceneTime = animateTimelineSceneTwo.time();
        let waitFor = 0;
        
        if (firstSceneTime <= animationTimes) {
            waitFor = waitFor + (animationTimes - firstSceneTime);
        }


        if (prevSceneTime <= animationTimes) {
            waitFor = waitFor + (animationTimes - prevSceneTime);
        }


        if (waitFor === 0) {
            animateTimelineSceneThree.time(0);
            animateTimelineSceneThree.paused(false);
            return;           
        }


        waitFor = waitFor * 1000;
        
        animateTimelineSceneThree.paused(true);
        animateTimelineSceneThree.time(0);

        animateTimelineSceneThreeTimeout = setTimeout(function() {
            animateTimelineSceneThree.paused(false);
        }, waitFor);

    });


    const timelineThreeX = {
        x1 : mobileView ? '+=105' : '-=105',
        x2 : mobileView ? '+=147' : '-=147',
        x3 : mobileView ? '-=147' : '+=147'
    }


    const animateTimelineSceneFour = new TimelineMax();
    animateTimelineSceneFour
        
        .to('#selectedPoint4', 0.25, { x: timelineThreeX.x1, ease: Power2.easeIn }, 0) // transition the dot to the right
        .to('#selectedLine4', 0.25, { attr: { x2: timelineThreeX.x1 }, ease: Power2.easeIn }, 0) // and expand the line along with the dot...
        .to('#timelineTitleClosed4', 0.25, { x: timelineThreeX.x1, ease: Power2.easeIn }, 0) // push the title out to the left too

        .to('#selectedPoint4', 0.25, { x: 0, morphSVG: '#selectedPoint4To'}, 0.25)  // morph the cirlce into the square...
        .fromTo('#bounceCircle4', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, 0.5 ) // bounce the circle...

        .to('#icon4Closed', 0.3, { x: timelineThreeX.x1, ease: Circ.easeIn }, 0 ) // animate the icon out of view
        .fromTo('#icon4Open', 0.3, { attr: { opacity: 1 }, x: timelineThreeX.x3 }, { x: timelineThreeX.x2, ease: Circ.easeOut }, 0.3 ) // animate the icon back into view

        .fromTo('#timelineTitleOpen4', 0.2, { transformOrigin : '50% 100%', visibility: 'visible', scaleY : 0, scaleX: 0.8 }, { scaleY : 1, scaleX: 1, ease: Power2.easeIn }, 0.75 )       
        .fromTo('#secureCloudTextGroup4', 0.3, { y: -71, visibility: 'visible' }, { y : 0, ease: Circ.easeIn }, 0.5); // animate the copy into view

        ;


    let animateTimelineSceneFourTimeout;

    const sceneFourD = new ScrollMagic.Scene({
        triggerElement: '#s4_trigger_4',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneFour)
    .on('start', function(event) {

        clearTimeout(animateTimelineSceneFourTimeout);
        const firstSceneTime = animateTimelineSceneOne.time();
        
        if (firstSceneTime === 0) {
            animateTimelineSceneFour.time(0);
            animateTimelineSceneFour.paused(false);
            return;
        }

        const secondSceneTime = animateTimelineSceneTwo.time();
        const prevSceneTime = animateTimelineSceneThree.time();
        let waitFor = 0;
        
        if (firstSceneTime <= animationTimes) {
            waitFor = waitFor + (animationTimes - firstSceneTime);
        }

        if (secondSceneTime <= animationTimes) {
            waitFor = waitFor + (animationTimes - secondSceneTime);
        }

        if (prevSceneTime <= animationTimes) {
            waitFor = waitFor + (animationTimes - prevSceneTime);
        }

        if (waitFor === 0) {
            animateTimelineSceneFour.time(0);
            animateTimelineSceneFour.paused(false);
            return;           
        }

        waitFor = waitFor * 1000;
        
        animateTimelineSceneFour.paused(true);
        animateTimelineSceneFour.time(0);

        animateTimelineSceneFourTimeout = setTimeout(function() {
            animateTimelineSceneFour.paused(false);
        }, waitFor);
     

    });


    // add it to our scenes holder
    scenes.push(sceneFourA);
    scenes.push(sceneFourB);
    scenes.push(sceneFourC);
    scenes.push(sceneFourD);

    
    const startTimelineAnimations = 0.25;

    const copyBlockSizeOne = h.getElementHeight('s4b_i1_copyInner');
    const animateTimelineSceneFourOne = new TimelineMax();
    
    if (mobileView) {

        animateTimelineSceneFourOne
            
            // transition the title out of view
            .to('#s4b_i1_title', 0.25, { x: '+=100%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // and the first image
            .to('#s4b_i1_image', 0.25, { css: { marginLeft: '0%' }, ease: Power2.easeOut }, startTimelineAnimations + 0)
            // extend the line
            .to('#s4b_i1_line', 0.25, { width: '85%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // morph the dot to a circle...
            .to('#s4b_i1_dotOrange', 0.25, { x: 0, morphSVG: '#s4b_i1_sqOrange'}, startTimelineAnimations + 0.25)
            // bounce the dot
            .fromTo('#s4b_i1_dotWhite', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, startTimelineAnimations + 0.5 ) // bounce the circle...
            // animate in the new title
            .fromTo('#s4b_i1_titleOpen', 0.3, { css: { transform : 'rotateX(90deg) translateY(-10px)', display: 'block' } }, { css: { transform : 'rotateX(0deg) translateY(0px)' }, ease: Power2.easeIn }, startTimelineAnimations + 0.25 )
            // show the copy
            .to('#s4b_i1_copy', 0.3, { height: `+=${copyBlockSizeOne}`, ease: Power2.easeIn }, startTimelineAnimations + 1)
            .fromTo('#s4b_i1_copyInner', 0.3, { y: `-${copyBlockSizeOne}px` }, { y: 0, ease: Power2.easeIn }, startTimelineAnimations + 1);

        }


    const sceneFourBA = new ScrollMagic.Scene({
        triggerElement: '#s4b_trigger_1',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneFourOne);


    const copyBlockSizeTwo = h.getElementHeight('s4b_i2_copyInner');
    const animateTimelineSceneFourTwo = new TimelineMax();
    
    if (mobileView) {

        animateTimelineSceneFourTwo
            
            // transition the title out of view
            .to('#s4b_i2_title', 0.25, { x: '+=100%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // and the first image
            .to('#s4b_i2_image', 0.25, { css: { marginLeft: '0%' }, ease: Power2.easeIn }, startTimelineAnimations + 0)
            // extend the line
            .to('#s4b_i2_line', 0.25, { width: '85%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // morph the dot to a circle...
            .to('#s4b_i2_dotOrange', 0.25, { x: 0, morphSVG: '#s4b_i2_sqOrange'}, startTimelineAnimations + 0.25)
            // bounce the dot
            .fromTo('#s4b_i2_dotWhite', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, startTimelineAnimations + 0.5 ) // bounce the circle...
            // animate in the new title
            .fromTo('#s4b_i2_titleOpen', 0.3, { css: { transform : 'rotateX(90deg) translateY(-10px)', display: 'block' } }, { css: { transform : 'rotateX(0deg) translateY(0px)' }, ease: Power2.easeIn }, startTimelineAnimations + 0.25 )
            // show the copy
            .to('#s4b_i2_copy', 0.3, { height: `+=${copyBlockSizeTwo}`, ease: Power2.easeIn }, startTimelineAnimations + 1)
            .fromTo('#s4b_i2_copyInner', 0.3, { y: `-${copyBlockSizeTwo}px` }, { y: 0, ease: Power2.easeIn }, startTimelineAnimations + 1);

    }

    const sceneFourBB = new ScrollMagic.Scene({
        triggerElement: '#s4b_trigger_2',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneFourTwo);



    const copyBlockSizeThree = h.getElementHeight('s4b_i3_copyInner');
    const animateTimelineSceneFourThree = new TimelineMax();
    
    if (mobileView) {

        animateTimelineSceneFourThree
            
            // transition the title out of view
            .to('#s4b_i3_title', 0.25, { x: '+=100%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // and the first image
            .to('#s4b_i3_image', 0.25, { css: { marginLeft: '0%' }, ease: Power2.easeIn }, startTimelineAnimations + 0)
            // extend the line
            .to('#s4b_i3_line', 0.25, { width: '85%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // morph the dot to a circle...
            .to('#s4b_i3_dotOrange', 0.25, { x: 0, morphSVG: '#s4b_i3_sqOrange'}, startTimelineAnimations + 0.25)
            // bounce the dot
            .fromTo('#s4b_i3_dotWhite', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, startTimelineAnimations + 0.5 ) // bounce the circle...
            // animate in the new title
            .fromTo('#s4b_i3_titleOpen', 0.3, { css: { transform : 'rotateX(90deg) translateY(-10px)', display: 'block' } }, { css: { transform : 'rotateX(0deg) translateY(0px)' }, ease: Power2.easeIn }, startTimelineAnimations + 0.25 )
            // show the copy
            .to('#s4b_i3_copy', 0.3, { height: `+=${copyBlockSizeThree}`, ease: Power2.easeIn }, startTimelineAnimations + 1)
            .fromTo('#s4b_i3_copyInner', 0.3, { y: `-${copyBlockSizeThree}px` }, { y: 0, ease: Power2.easeIn }, startTimelineAnimations + 1);

    }

    const sceneFourBC = new ScrollMagic.Scene({
        triggerElement: '#s4b_trigger_3',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneFourThree);



    const copyBlockSizeFour = h.getElementHeight('s4b_i4_copyInner');
    const animateTimelineSceneFourFour = new TimelineMax();
    
    if (mobileView) {

        animateTimelineSceneFourFour
            
            // transition the title out of view
            .to('#s4b_i4_title', 0.25, { x: '+=100%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // and the first image
            .to('#s4b_i4_image', 0.25, { css: { marginLeft: '0%' }, ease: Power2.easeIn }, startTimelineAnimations + 0)
            // extend the line
            .to('#s4b_i4_line', 0.25, { width: '85%', ease: Power2.easeIn }, startTimelineAnimations + 0)
            // morph the dot to a circle...
            .to('#s4b_i4_dotOrange', 0.25, { x: 0, morphSVG: '#s4b_i4_sqOrange'}, startTimelineAnimations + 0.25)
            // bounce the dot
            .fromTo('#s4b_i4_dotWhite', 1.5, { y: -15, visibility: 'visible' }, { y: 0, ease: Elastic.easeOut.config(1, 0.2) }, startTimelineAnimations + 0.5 ) // bounce the circle...
            // animate in the new title
            .fromTo('#s4b_i4_titleOpen', 0.3, { css: { transform : 'rotateX(90deg) translateY(-10px)', display: 'block' } }, { css: { transform : 'rotateX(0deg) translateY(0px)' }, ease: Power2.easeIn }, startTimelineAnimations + 0.25 )
            // show the copy
            .to('#s4b_i4_copy', 0.3, { height: `+=${copyBlockSizeFour}`, ease: Power2.easeIn }, startTimelineAnimations + 1)
            .fromTo('#s4b_i4_copyInner', 0.3, { y: `-${copyBlockSizeFour}px` }, { y: 0, ease: Power2.easeIn }, startTimelineAnimations + 1);

    }

    const sceneFourBD = new ScrollMagic.Scene({
        triggerElement: '#s4b_trigger_4',
        offset: defaults.offset(),
        reverse: false
    }).setTween(animateTimelineSceneFourFour);




    scenes.push(sceneFourBA);
    scenes.push(sceneFourBB);
    scenes.push(sceneFourBC);
    scenes.push(sceneFourBD);


    /**
     * Summary Scene
     */
    
    const summaryAnimation = new TimelineMax();
    summaryAnimation.set('#txt1', { attr : { 'width' : 0 } })
    .set('#txt2', { attr : { 'width' : 0 } })
    .set('#txt3', { attr : { 'width' : 0 } })
    .to('#txt1', 0.25, { attr : { 'width' : 69 }, ease: Power2.easeInOut }, 0)
    .to('#txt2', 0.25, { attr : { 'width' : 69 }, ease: Power2.easeInOut }, 0.15)
    .to('#txt3', 0.25, { attr : { 'width' : 48 }, ease: Power2.easeInOut }, 0.3);

    // animate the quote marks (not on a scene as will move constantly)
    
    const animateQuotes = new TimelineMax({repeat: -1});
    animateQuotes.fromTo('#clippedQuotes', 2, { x : 0 }, { x : '-36%', ease: Linear.easeNone }, 0);

    const sceneSummary = new ScrollMagic.Scene({
        triggerElement: '#summary_trigger',
        offset: defaults.offset()
    }).setTween(summaryAnimation);

    // add it to our scenes holder
    scenes.push(sceneSummary);



    // add our scenes to our scroll magic container
    scroll.addScene(scenes);


}



document.addEventListener("DOMContentLoaded", function(event) { 
    
    if (detectIE()) {
        document.getElementsByTagName("body")[0].classList.add('ie');
        setHeightOfSVGContainers();
    }

    //prepareSVGs();
    
    setUpAnimations();

    window.on('resize', resizing);
    
});


function setHeightOfSVGContainers() {
    
    const containerWidth = h.getElementWidth('intro_trigger');

    // intro image is 0.5486 height of container width
    const introImageHeight = containerWidth * 0.5486;
    document.getElementById('intro_graphic_container').style.height = introImageHeight +'px';

    // modern analytics platform svg should be 174% in height compared to it's width
    const secureCloudSVGWidth = containerWidth * 0.8;
    document.getElementById('secureCloud').style.width = secureCloudSVGWidth+'px';
    document.getElementById('secureCloud').style.height = (secureCloudSVGWidth*1.74)+'px';


    // set the background size for the cloud box in Scene 3
    const topCloudRatio = 0.359;
    const bottomCloudRatio = 390 / 1920;
    const cloudWidth = containerWidth + 1;
    const topCloudHeight = containerWidth * topCloudRatio;
    const bottomCloudHeight = containerWidth * bottomCloudRatio;
    $('#s3Background').style.backgroundSize = `${cloudWidth}px ${topCloudHeight}px, ${cloudWidth}px ${bottomCloudHeight}px`;

}


function detectIE() {
  
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  // other browser
  return false;
}


/*
For use with GreenSock's MorphSVGPlugin - helps find the best-looking shapeIndex value. 

USAGE: 
findShapeIndex("#yourTarget", "#otherShape", {duration:3, ease:Linear.easeNone, size:10});

You can pass in either the other shape's selector text, or the full path data, like:

findShapeIndex("#yourTarget", "M506.066,200L400,306.066L293.934,200L400,93.934L506.066,200z", {duration:3, ease:Linear.easeNone, size:10});

Tap the up/down arrows (or left/right or "u"/"d") to change the shapeIndex.

Requires: TweenLite 1.18.0 (or later), MorphSVGPlugin

LAST UPDATED: 2015-10-21
Copyright 2015, GreenSock Inc. 
@author: Jack Doyle, jack@greensock.com
*/
function findShapeIndex(target, endShape, vars) {
    vars = vars || {};
    var _doc = document,
            TweenLite = (window.GreenSockGlobals || window).TweenLite,
            _get = function(e) {
                return _doc.querySelectorAll(e);
            },
            _createSVG = function(type, attributes) {
                var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
                        reg = /([a-z])([A-Z])/g,
                        p;
                for (p in attributes) {
                    element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
                }
                return element;
            },
            _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
            _parseShape = function(shape, forcePath) {
                var e, type;
                if (typeof(shape) !== "string" || (shape.match(_numbersExp) || []).length < 3) {
                    e = TweenLite.selector(shape);
                    if (e && e[0]) {
                        e = e[0];
                        type = e.nodeName.toUpperCase();
                        if (forcePath && type !== "PATH") { //if we were passed an element (or selector text for an element) that isn't a path, convert it.
                            e = MorphSVGPlugin.convertToPath(e, false)[0];
                            type = "PATH";
                        }
                        shape = e.getAttribute(type === "PATH" ? "d" : "points") || "";
                    }
                    else {
                        console.log("WARNING: invalid morph to: " + shape);
                        shape = false;
                    }
                }
                return shape;
            },
            startDot, endDot, incrementButton, decrementButton,
            _setup = function() {
                var e = _doc.createElement("div"),
                        label = _doc.createElement("div"),
                        body = _get("body")[0];
                incrementButton = _doc.createElement("div");
                decrementButton = _doc.createElement("div");
                label.setAttribute("id", "shapeIndexLabel");
                startDot = _createSVG("circle", {cx:0, cy:0, r:(vars.startStrokeWidth || 3) + 3, fill:vars.startStroke || "red"});
                endDot = _createSVG("circle", {cx:0, cy:0, r:(vars.endStrokeWidth || 3) + 3, fill:vars.endStroke || "yellow"});
                TweenLite.set(e, {padding:"0px", position:"fixed", bottom:0, fontSize:"20px", textAlign:"center", backgroundColor: "black", color:"#91e600", border:"1px solid #999", left:"50%", xPercent:-50, yPercent:-50, userSelect:"none", fontFamily:"sans-serif"});
                TweenLite.set(label, {display:"inline-block", minWidth:"210px", marginRight:"10px", textAlign:"center", marginLeft:"10px"});
                TweenLite.set([incrementButton, decrementButton], {display:"inline-block", padding:"0 15px", color:"#ccc", height:"50px", lineHeight:"48px", cursor:"pointer"});
                TweenLite.set(decrementButton, {borderRight:"1px solid #999"});
                TweenLite.set(incrementButton, {borderLeft:"1px solid #999"});
                decrementButton.innerHTML = " - ";
                incrementButton.innerHTML = " + ";
                e.appendChild(decrementButton);
                e.appendChild(label);
                e.appendChild(incrementButton);
                if (body) {
                    body.appendChild(e);
                }
                return label;
            },
            label = _get("#shapeIndexLabel")[0] || _setup(),
            index = 0,
            _yoyo = function() {
                shapeTween.reversed(!shapeTween.reversed()).resume();
                dotTween.reversed(!dotTween.reversed()).resume();
            },
            shapeTween, dotTween, startBezier, endBezier,
            dotProxy = {x:0, y:0},
            _getFirstCoordinates = function(start, end, shapeIndex) {
                startBezier = MorphSVGPlugin.pathDataToRawBezier(start);
                endBezier = MorphSVGPlugin.pathDataToRawBezier(end);
                MorphSVGPlugin.equalizeSegmentQuantity(startBezier, endBezier, shapeIndex);
                return [startBezier[0][0], startBezier[0][1], endBezier[0][0], endBezier[0][1]];
            },
            _startTween = function() {
                var coordinates = _getFirstCoordinates(target.getAttribute("d"), _parseShape(endShape, true), index);
                dotProxy.x = coordinates[0];
                dotProxy.y = coordinates[1];
                startDot.setAttribute("cx", dotProxy.x);
                startDot.setAttribute("cy", dotProxy.y);
                endDot.setAttribute("cx", coordinates[2]);
                endDot.setAttribute("cy", coordinates[3]);
                shapeTween = TweenLite.to(target, vars.duration || 3, {delay:0.5, morphSVG:{shape:endShape, shapeIndex:index}, ease:vars.ease || "Linear.easeNone", onComplete:_yoyo, onReverseComplete:_yoyo});
                dotTween = TweenLite.to(dotProxy, vars.duration || 3, {delay:0.5, x:coordinates[2], y:coordinates[3], ease:vars.ease || "Linear.easeNone", onUpdate:function() {
                    startDot.setAttribute("cx", dotProxy.x);
                    startDot.setAttribute("cy", dotProxy.y);
                }});
            },
            _refresh = function() {
                label.innerHTML = "shapeIndex: " +  index + (index === autoIndex ? " (auto)" : "");
                shapeTween.seek(0).kill();
                dotTween.seek(0).kill();
                _startTween();
                TweenLite.fromTo(label.parentNode, 0.4, {backgroundColor:"#777"}, {backgroundColor:"black", ease:Linear.easeNone});
            },
            _increment = function() {
                index = (index + 1) % (maxIndex + 1);
                _refresh();
            },
            _decrement = function() {
                index = (index - 1) % (maxIndex + 1);
                _refresh();
            },
            autoIndex,  maxIndex, endTarget;
    if (typeof(target) === "string") {
        target = TweenLite.selector(target)[0];
    }
    if (!target) {
        console.log("ERROR: target not found for findShapeIndex(). Please use a valid target.");
        return;
    } else if (target.nodeName && target.nodeName.toUpperCase() !== "PATH") {
        console.log("ERROR: target of findShapeIndex() must be a path.");
        return;
    } else if (target.push && target[0] && target[0].nodeName) {
        target = target[0];
    }
    if (target.parentNode) {
        target.parentNode.appendChild(endDot);
        target.parentNode.appendChild(startDot);
    }
    if (typeof(endShape) !== "string" || (endShape.match(_numbersExp) || []).length < 3) {
        endTarget = TweenLite.selector(endShape);
        if (endTarget && endTarget[0]) {
            endTarget = endTarget[0];
            TweenLite.set(endTarget, {display:"block", strokeWidth:vars.endStrokeWidth || 3, stroke:vars.endStroke || "yellow", fill:vars.endFill || "none", visibility:"visible", opacity:vars.endOpacity || 0.7});
        }
    }
    TweenLite.set(target, {display:"block", strokeWidth:vars.startStrokeWidth || 3, stroke:vars.startStroke || "red", fill:vars.startFill || "none", visibility:"visible", opacity:vars.startOpacity || 0.7});
    startBezier = MorphSVGPlugin.pathDataToRawBezier(target.getAttribute("d"));
    endBezier = MorphSVGPlugin.pathDataToRawBezier(_parseShape(endShape, true));
    autoIndex = index = Math.round(MorphSVGPlugin.equalizeSegmentQuantity(startBezier, endBezier, "auto")[0]); //also handles subdividing!
    maxIndex = (startBezier[0].length / 6) | 0;
    TweenLite.killTweensOf([target, endShape], false, {morphSVG:true}); //kill other tweens so they don't interfere with our yoyo-ing one.
    _startTween();
    label.innerHTML = "shapeIndex: " +  index + (index === autoIndex ? " (auto)" : "");
    window.addEventListener("keydown", function(event) {
        var key = event.keyCode;
        if (key === 38 || key === 39 || key === 85) { //right or up arrows (increment)
            _increment();
        } else if (key === 37 || key === 40 || key === 68) { //left or down arrows (decrement)
            _decrement();
        }
    });
    incrementButton.addEventListener("click", _increment);
    decrementButton.addEventListener("click", _decrement);
}


// WEBPACK FOOTER //
// ./app/js/main.js